const injuriesData = [
  {
    "name": "Petr Mrazek",
    "position": "G",
    "updated": "Sep 15",
    "injury": "Injured Reserve",
    "date_return": "Feb 18: Mrazek underwent season-ending hip surgery Tuesday."
  },
  {
    "name": "Jiri Kulich",
    "position": "C",
    "updated": "Sep 15",
    "injury": "Injured Reserve",
    "date_return": "Mar 6: Kulich (ear) has been improving but will likely miss the rest of the regular season, Paul Hamilton of WGR Sports Radio 550 reports Friday."
  },
  {
    "name": "Justin Danforth",
    "position": "RW",
    "updated": "Apr 13",
    "injury": "Injured Reserve",
    "date_return": "Jan 26: Danforth (lower body) is trending toward a post-Olympic return to action, Bill Hoppe of the Olean Times Herald reports Monday."
  },
  {
    "name": "Samuel Honzek",
    "position": "LW",
    "updated": "Sep 15",
    "injury": "Injured Reserve",
    "date_return": "Mar 27: Honzek (upper body) will not return this season, per Pat Steinberg of Sportsnet 960 The Fan on Friday."
  },
  {
    "name": "Jonathan Huberdeau",
    "position": "LW",
    "updated": "Sep 15",
    "injury": "Injured Reserve",
    "date_return": "Feb 21: Huberdeau (hip) was put on injured reserve Saturday, per the NHL media site."
  },
  {
    "name": "Taylor Hall",
    "position": "LW",
    "updated": "Apr 13",
    "injury": "Day-To-Day",
    "date_return": ""
  },
  {
    "name": "Mark Jankowski",
    "position": "LW",
    "updated": "Apr 13",
    "injury": "Day-To-Day",
    "date_return": ""
  },
  {
    "name": "K'Andre Miller",
    "position": "D",
    "updated": "Apr 13",
    "injury": "Day-To-Day",
    "date_return": ""
  },
  {
    "name": "Jalen Chatfield",
    "position": "D",
    "updated": "Apr 13",
    "injury": "Day-To-Day",
    "date_return": ""
  },
  {
    "name": "Logan Stankoven",
    "position": "C",
    "updated": "Apr 13",
    "injury": "Day-To-Day",
    "date_return": ""
  },
  {
    "name": "Jackson Blake",
    "position": "RW",
    "updated": "Apr 13",
    "injury": "Day-To-Day",
    "date_return": ""
  },
  {
    "name": "William Carrier",
    "position": "LW",
    "updated": "Apr 13",
    "injury": "Day-To-Day",
    "date_return": ""
  },
  {
    "name": "Pyotr Kochetkov",
    "position": "G",
    "updated": "Apr 18",
    "injury": "Injured Reserve",
    "date_return": "Apr 10: Kochetkov (hip) was assigned to AHL Chicago on Friday for a conditioning stint."
  },
  {
    "name": "Ethan Del Mastro",
    "position": "D",
    "updated": "Apr 13",
    "injury": "Day-To-Day",
    "date_return": ""
  },
  {
    "name": "Andrew Mangiapane",
    "position": "LW",
    "updated": "Apr 13",
    "injury": "Day-To-Day",
    "date_return": ""
  },
  {
    "name": "Frank Nazar",
    "position": "C",
    "updated": "Apr 13",
    "injury": "Day-To-Day",
    "date_return": "Apr 11: Nazar (face) won't return to Saturday's game versus the Blues."
  },
  {
    "name": "Ryan Ellis",
    "position": "D",
    "updated": "Jul 1",
    "injury": "Injured Reserve",
    "date_return": "Jan 8: Ellis (back) and his contract have been traded to Chicago from San Jose, along with Jake Furlong and a 2028 fourth-round pick in exchange for Laurent Brossoit, Nolan Allan and a 2028 seventh-round pick Thursday."
  },
  {
    "name": "Shea Weber",
    "position": "D",
    "updated": "Jul 1",
    "injury": "Injured Reserve",
    "date_return": "Sep 30: ir-lt"
  },
  {
    "name": "Cale Makar",
    "position": "D",
    "updated": "Apr 13",
    "injury": "Day-To-Day",
    "date_return": ""
  },
  {
    "name": "Josh Manson",
    "position": "D",
    "updated": "Apr 13",
    "injury": "Day-To-Day",
    "date_return": ""
  },
  {
    "name": "Nils Lundkvist",
    "position": "D",
    "updated": "Apr 13",
    "injury": "Day-To-Day",
    "date_return": ""
  },
  {
    "name": "Radek Faksa",
    "position": "C",
    "updated": "Apr 13",
    "injury": "Injured Reserve",
    "date_return": "Apr 6: Faksa (lower body) won't be an option against the Flames on Tuesday but is nearing a return to action, Brien Rea of Victory+ reports."
  },
  {
    "name": "Tyler Seguin",
    "position": "C",
    "updated": "Sep 15",
    "injury": "Injured Reserve",
    "date_return": "Feb 27: Seguin (knee) will miss the remainder of the 2025-26 campaign and the entirety of the playoffs, Elliotte Friedman of Sportsnet reports Thursday."
  },
  {
    "name": "Mason Appleton",
    "position": "C",
    "updated": "Apr 13",
    "injury": "Day-To-Day",
    "date_return": ""
  },
  {
    "name": "Max Jones",
    "position": "LW",
    "updated": "Apr 13",
    "injury": "Day-To-Day",
    "date_return": ""
  },
  {
    "name": "Jason Dickinson",
    "position": "C",
    "updated": "Apr 13",
    "injury": "Day-To-Day",
    "date_return": ""
  },
  {
    "name": "Leon Draisaitl",
    "position": "C",
    "updated": "Apr 18",
    "injury": "Injured Reserve",
    "date_return": "Apr 6: Draisaitl (lower body) has not started skating but is expected to get on the ice soon, Tony Brar of Oilers TV reports Monday."
  },
  {
    "name": "Mattias Janmark",
    "position": "C",
    "updated": "Sep 15",
    "injury": "Injured Reserve",
    "date_return": "Mar 6: Janmark (undisclosed) underwent season-ending surgery on Friday, per Mark Spector of Sportsnet."
  },
  {
    "name": "Carter Verhaeghe",
    "position": "C",
    "updated": "Apr 13",
    "injury": "Day-To-Day",
    "date_return": ""
  },
  {
    "name": "Sam Bennett",
    "position": "C",
    "updated": "Apr 13",
    "injury": "Day-To-Day",
    "date_return": ""
  },
  {
    "name": "Evan Rodrigues",
    "position": "C",
    "updated": "Sep 15",
    "injury": "Injured Reserve",
    "date_return": "Apr 4: ir-lt"
  },
  {
    "name": "Jonah Gadjovich",
    "position": "LW",
    "updated": "Sep 15",
    "injury": "Injured Reserve",
    "date_return": "Mar 31: Gadjovich (upper body) is not expected to suit up again this season, per Jameson Olive of the Panthers' official site on Tuesday."
  },
  {
    "name": "Aleksander Barkov",
    "position": "C",
    "updated": "Sep 15",
    "injury": "Injured Reserve",
    "date_return": "Mar 30: As expected, Barkov (knee) won't return before the end of the 2025-26 season, per George Richards of Florida Hockey Now on Monday."
  },
  {
    "name": "Niko Mikkola",
    "position": "D",
    "updated": "Sep 15",
    "injury": "Injured Reserve",
    "date_return": ""
  },
  {
    "name": "Brad Marchand",
    "position": "LW",
    "updated": "Sep 15",
    "injury": "Injured Reserve",
    "date_return": "Mar 17: Marchand landed on injured reserve Tuesday, per the NHL media site."
  },
  {
    "name": "Jeff Malott",
    "position": "LW",
    "updated": "Apr 13",
    "injury": "Day-To-Day",
    "date_return": ""
  },
  {
    "name": "Andrei Kuzmenko",
    "position": "LW",
    "updated": "Apr 16",
    "injury": "Injured Reserve",
    "date_return": "Apr 8: Kuzmenko (knee) is making strides in his recovery and will be reevaluated in 7-8 days, Alexander Legget of Mayors Manor reports Wednesday."
  },
  {
    "name": "Kevin Fiala",
    "position": "LW",
    "updated": "Sep 15",
    "injury": "Injured Reserve",
    "date_return": "Mar 6: Fiala (lower leg fracture) won't be available before training camp for the 2026-27 campaign, per John Hoven of SiriusXM NHL Network Radio."
  },
  {
    "name": "Zach Bogosian",
    "position": "D",
    "updated": "Apr 14",
    "injury": "Day-To-Day",
    "date_return": ""
  },
  {
    "name": "Mats Zuccarello",
    "position": "RW",
    "updated": "Apr 13",
    "injury": "Day-To-Day",
    "date_return": ""
  },
  {
    "name": "Jared Spurgeon",
    "position": "D",
    "updated": "Apr 13",
    "injury": "Day-To-Day",
    "date_return": ""
  },
  {
    "name": "Joel Eriksson Ek",
    "position": "C",
    "updated": "Apr 13",
    "injury": "Day-To-Day",
    "date_return": ""
  },
  {
    "name": "Patrik Laine",
    "position": "RW",
    "updated": "Apr 14",
    "injury": "Injured Reserve",
    "date_return": "Jan 10: Laine (abdomen) is practicing Saturday in a non-contact jersey, Renaud Lavoie of TVA Sports reports."
  },
  {
    "name": "Nicolas Hague",
    "position": "D",
    "updated": "Apr 13",
    "injury": "Day-To-Day",
    "date_return": ""
  },
  {
    "name": "Stefan Noesen",
    "position": "RW",
    "updated": "Oct 15",
    "injury": "Injured Reserve",
    "date_return": "Mar 22: Noesen (knee) has been ruled out for the rest of the season, Kristy Flannery of The Hockey News reports Sunday."
  },
  {
    "name": "Zack MacEwen",
    "position": "RW",
    "updated": "Sep 15",
    "injury": "Injured Reserve",
    "date_return": "Jan 10: MacEwen had knee surgery and will be lost for the remainder of the season, Kristy Flannery of The Hockey News reports Saturday."
  },
  {
    "name": "Alexander Romanov",
    "position": "D",
    "updated": "Apr 18",
    "injury": "Injured Reserve",
    "date_return": "Apr 12: Romanov (shoulder) will miss the final two games of the regular season, according to Stefen Rosner of NHL.com on Sunday."
  },
  {
    "name": "Pierre Engvall",
    "position": "LW",
    "updated": "Sep 15",
    "injury": "Injured Reserve",
    "date_return": "Mar 12: Engvall (ankle) will miss the remainder of the 2025-26 campaign, per Stefen Rosner of NHL.com."
  },
  {
    "name": "Semyon Varlamov",
    "position": "G",
    "updated": "Sep 15",
    "injury": "Injured Reserve",
    "date_return": "Mar 12: Varlamov (knee) has been ruled out for the remainder of the season, Stefen Rosner of NHL.com reports Thursday."
  },
  {
    "name": "Kyle Palmieri",
    "position": "C",
    "updated": "Sep 15",
    "injury": "Injured Reserve",
    "date_return": ""
  },
  {
    "name": "Matt Rempe",
    "position": "C",
    "updated": "Sep 15",
    "injury": "Injured Reserve",
    "date_return": "Mar 23: Rempe (thumb) probably won't be ready to return before the end of the 2025-26 regular season, according to Vince Z. Mercogliano of The Athletic on Monday."
  },
  {
    "name": "Nick Jensen",
    "position": "D",
    "updated": "Apr 28",
    "injury": "Injured Reserve",
    "date_return": ""
  },
  {
    "name": "Rodrigo Abols",
    "position": "C",
    "updated": "Apr 14",
    "injury": "Injured Reserve",
    "date_return": "Jan 21: Abols' injury is a fractured right ankle, Kevin Kurz of The Athletic reports Wednesday."
  },
  {
    "name": "Caleb Jones",
    "position": "D",
    "updated": "Sep 15",
    "injury": "Injured Reserve",
    "date_return": ""
  },
  {
    "name": "Filip Hallander",
    "position": "C",
    "updated": "Apr 25",
    "injury": "Injured Reserve",
    "date_return": "Feb 27: Hallander (leg) was recalled from his conditioning stint with AHL Wilkes-Barre/Scranton on Friday, Seth Rorabaugh of Tribune-Review Sports reports."
  },
  {
    "name": "Logan Couture",
    "position": "C",
    "updated": "Sep 15",
    "injury": "Injured Reserve",
    "date_return": "Sep 30: ir-lt"
  },
  {
    "name": "Shane Wright",
    "position": "C",
    "updated": "Apr 13",
    "injury": "Day-To-Day",
    "date_return": ""
  },
  {
    "name": "Philipp Grubauer",
    "position": "G",
    "updated": "Apr 13",
    "injury": "Day-To-Day",
    "date_return": ""
  },
  {
    "name": "Joey Daccord",
    "position": "G",
    "updated": "Apr 13",
    "injury": "Day-To-Day",
    "date_return": ""
  },
  {
    "name": "Zemgus Girgensons",
    "position": "C",
    "updated": "Apr 13",
    "injury": "Day-To-Day",
    "date_return": ""
  },
  {
    "name": "Darren Raddysh",
    "position": "D",
    "updated": "Apr 13",
    "injury": "Day-To-Day",
    "date_return": ""
  },
  {
    "name": "Victor Hedman",
    "position": "D",
    "updated": "Apr 15",
    "injury": "Injured Reserve",
    "date_return": "Apr 2: ir-lt"
  },
  {
    "name": "Maxwell Crozier",
    "position": "D",
    "updated": "Apr 29",
    "injury": "Injured Reserve",
    "date_return": "Mar 19: ir-lt"
  },
  {
    "name": "Dominic James",
    "position": "C",
    "updated": "Apr 30",
    "injury": "Injured Reserve",
    "date_return": "Mar 5: James (leg) will be sidelined for 8-10 weeks after undergoing surgery, Benjamin Pierce of the Lightning's official site reports Thursday."
  },
  {
    "name": "Chris Tanev",
    "position": "D",
    "updated": "Sep 15",
    "injury": "Injured Reserve",
    "date_return": "Mar 4: Tanev underwent core muscle surgery Wednesday and will miss the remainder of the 2025-26 campaign."
  },
  {
    "name": "Thatcher Demko",
    "position": "G",
    "updated": "Sep 15",
    "injury": "Injured Reserve",
    "date_return": "Mar 3: Demko was placed on long-term injured reserve Tuesday."
  },
  {
    "name": "Filip Chytil",
    "position": "C",
    "updated": "Apr 16",
    "injury": "Injured Reserve",
    "date_return": ""
  },
  {
    "name": "Derek Forbort",
    "position": "D",
    "updated": "Apr 16",
    "injury": "Injured Reserve",
    "date_return": "Oct 28: Forbort (undisclosed) was placed on long-term injured reserve Tuesday."
  },
  {
    "name": "Gustav Nyquist",
    "position": "RW",
    "updated": "Apr 13",
    "injury": "Day-To-Day",
    "date_return": ""
  },
  {
    "name": "Colin Miller",
    "position": "D",
    "updated": "Apr 16",
    "injury": "Injured Reserve",
    "date_return": "Mar 10: Miller (knee) has resumed skating but is not close to returning to the lineup, Mitchell Clinton of the Jets' official site reports Tuesday."
  }
];

export default injuriesData;
